// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.donate-layout {
  display: grid;
  grid-template-columns: 1fr 360px;
  gap: 32px;
  align-items: start;
}

.donate-form {
  display: flex;
  flex-direction: column;
  gap: 28px;
}

.donate-form h2 {
  font-size: 1.5rem;
  margin-bottom: 4px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.form-label {
  font-size: 0.9rem;
  font-weight: 600;
  color: var(--gold-dark);
}

.causes-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
}

.cause-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 16px;
  border: 1.5px solid rgba(200,134,10,0.2);
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 0.85rem;
  font-weight: 500;
  color: var(--text-mid);
}

.cause-item.selected {
  border-color: var(--gold);
  background: rgba(200,134,10,0.08);
  color: var(--gold-dark);
}

.cause-emoji {
  font-size: 1.2rem;
}

.cause-desc {
  font-size: 0.82rem;
  color: var(--text-light);
  line-height: 1.6;
}

.amount-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
}

.amount-btn {
  padding: 12px;
  border: 1.5px solid rgba(200,134,10,0.25);
  border-radius: 10px;
  background: transparent;
  font-family: 'Poppins', sans-serif;
  font-size: 0.95rem;
  font-weight: 600;
  color: var(--text-mid);
  cursor: pointer;
  transition: all 0.2s ease;
}

.amount-btn.selected,
.amount-btn:hover {
  border-color: var(--gold);
  background: rgba(200,134,10,0.1);
  color: var(--gold-dark);
}

.custom-amount {
  display: flex;
  align-items: center;
  border: 1.5px solid rgba(200,134,10,0.25);
  border-radius: 10px;
  overflow: hidden;
  background: var(--cream);
}

.rupee-prefix {
  padding: 0 14px;
  font-weight: 600;
  color: var(--gold);
  font-size: 1rem;
  border-right: 1.5px solid rgba(200,134,10,0.2);
}

.custom-amount input {
  border: none;
  background: transparent;
  padding: 12px 14px;
  font-family: 'Poppins', sans-serif;
  font-size: 0.95rem;
  color: var(--text-dark);
  width: 100%;
  outline: none;
}

.anonymous-toggle {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  font-size: 0.88rem;
  color: var(--text-mid);
}

.anonymous-toggle input {
  width: 16px;
  height: 16px;
  accent-color: var(--gold);
}

.donor-fields {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.form-input {
  padding: 12px 16px;
  border: 1.5px solid rgba(200,134,10,0.2);
  border-radius: 10px;
  font-family: 'Poppins', sans-serif;
  font-size: 0.9rem;
  color: var(--text-dark);
  background: var(--cream);
  outline: none;
  transition: border-color 0.2s ease;
}

.form-input:focus {
  border-color: var(--gold);
}

.donate-submit {
  width: 100%;
  font-size: 1.05rem;
  padding: 16px;
}

.donate-secure {
  text-align: center;
  font-size: 0.8rem;
  color: var(--text-light);
}

/* Sidebar */
.donate-sidebar {
  display: flex;
  flex-direction: column;
  gap: 20px;
  position: sticky;
  top: 90px;
}

.impact-card h3,
.donors-card h3,
.trust-card h3 {
  font-size: 1rem;
  margin-bottom: 16px;
}

.impact-items {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.impact-item {
  display: grid;
  grid-template-columns: 72px 1fr;
  gap: 10px;
  align-items: start;
}

.impact-amount {
  font-weight: 700;
  color: var(--gold);
  font-size: 0.9rem;
  white-space: nowrap;
  padding-top: 1px;
}

.impact-desc {
  font-size: 0.82rem;
  color: var(--text-mid);
  line-height: 1.5;
}

.donors-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.donor-row {
  display: flex;
  align-items: center;
  gap: 12px;
}

.donor-avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: linear-gradient(135deg, rgba(200,134,10,0.15), rgba(196,72,10,0.1));
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1rem;
  font-weight: 700;
  color: var(--gold-dark);
  flex-shrink: 0;
}

.donor-info {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 1px;
}

.donor-info strong {
  font-size: 0.85rem;
  color: var(--text-dark);
}

.donor-info span {
  font-size: 0.75rem;
  color: var(--text-light);
}

.donor-right {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 2px;
}

.donor-amount {
  font-size: 0.9rem;
  font-weight: 700;
  color: var(--gold-dark);
}

.donor-time {
  font-size: 0.72rem;
  color: var(--text-light);
}

.trust-card ul {
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.trust-card li {
  font-size: 0.85rem;
  color: var(--text-mid);
}

/* Success */
.success-card {
  text-align: center;
  padding: 48px 40px;
  max-width: 560px;
  margin: 0 auto;
}

.success-card h2 {
  font-size: 1.8rem;
  margin: 16px 0 12px;
}

.success-card p {
  color: var(--text-mid);
  line-height: 1.8;
}

@media (max-width: 960px) {
  .donate-layout {
    grid-template-columns: 1fr;
  }

  .donate-sidebar {
    position: static;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 20px;
  }

  .trust-card {
    grid-column: 1 / -1;
  }
}

@media (max-width: 560px) {
  .causes-grid { grid-template-columns: 1fr; }
  .amount-grid { grid-template-columns: repeat(2, 1fr); }
  .donate-sidebar { grid-template-columns: 1fr; }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Donate.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,wCAAwC;EACxC,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,iCAAiC;EACjC,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,yCAAyC;EACzC,mBAAmB;EACnB,uBAAuB;EACvB,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;EACzB,gCAAgC;EAChC,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yCAAyC;EACzC,mBAAmB;EACnB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,8CAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,kCAAkC;EAClC,kBAAkB;EAClB,uBAAuB;EACvB,WAAW;EACX,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,wCAAwC;EACxC,mBAAmB;EACnB,kCAAkC;EAClC,iBAAiB;EACjB,uBAAuB;EACvB,wBAAwB;EACxB,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,SAAS;AACX;;AAEA;;;EAGE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,+EAA+E;EAC/E,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA,YAAY;AACZ;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,gBAAgB;IAChB,aAAa;IACb,8BAA8B;IAC9B,SAAS;EACX;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,eAAe,0BAA0B,EAAE;EAC3C,eAAe,qCAAqC,EAAE;EACtD,kBAAkB,0BAA0B,EAAE;AAChD","sourcesContent":[".donate-layout {\n  display: grid;\n  grid-template-columns: 1fr 360px;\n  gap: 32px;\n  align-items: start;\n}\n\n.donate-form {\n  display: flex;\n  flex-direction: column;\n  gap: 28px;\n}\n\n.donate-form h2 {\n  font-size: 1.5rem;\n  margin-bottom: 4px;\n}\n\n.form-group {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.form-label {\n  font-size: 0.9rem;\n  font-weight: 600;\n  color: var(--gold-dark);\n}\n\n.causes-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 10px;\n}\n\n.cause-item {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 12px 16px;\n  border: 1.5px solid rgba(200,134,10,0.2);\n  border-radius: 10px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  font-size: 0.85rem;\n  font-weight: 500;\n  color: var(--text-mid);\n}\n\n.cause-item.selected {\n  border-color: var(--gold);\n  background: rgba(200,134,10,0.08);\n  color: var(--gold-dark);\n}\n\n.cause-emoji {\n  font-size: 1.2rem;\n}\n\n.cause-desc {\n  font-size: 0.82rem;\n  color: var(--text-light);\n  line-height: 1.6;\n}\n\n.amount-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 10px;\n}\n\n.amount-btn {\n  padding: 12px;\n  border: 1.5px solid rgba(200,134,10,0.25);\n  border-radius: 10px;\n  background: transparent;\n  font-family: 'Poppins', sans-serif;\n  font-size: 0.95rem;\n  font-weight: 600;\n  color: var(--text-mid);\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.amount-btn.selected,\n.amount-btn:hover {\n  border-color: var(--gold);\n  background: rgba(200,134,10,0.1);\n  color: var(--gold-dark);\n}\n\n.custom-amount {\n  display: flex;\n  align-items: center;\n  border: 1.5px solid rgba(200,134,10,0.25);\n  border-radius: 10px;\n  overflow: hidden;\n  background: var(--cream);\n}\n\n.rupee-prefix {\n  padding: 0 14px;\n  font-weight: 600;\n  color: var(--gold);\n  font-size: 1rem;\n  border-right: 1.5px solid rgba(200,134,10,0.2);\n}\n\n.custom-amount input {\n  border: none;\n  background: transparent;\n  padding: 12px 14px;\n  font-family: 'Poppins', sans-serif;\n  font-size: 0.95rem;\n  color: var(--text-dark);\n  width: 100%;\n  outline: none;\n}\n\n.anonymous-toggle {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n  font-size: 0.88rem;\n  color: var(--text-mid);\n}\n\n.anonymous-toggle input {\n  width: 16px;\n  height: 16px;\n  accent-color: var(--gold);\n}\n\n.donor-fields {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.form-input {\n  padding: 12px 16px;\n  border: 1.5px solid rgba(200,134,10,0.2);\n  border-radius: 10px;\n  font-family: 'Poppins', sans-serif;\n  font-size: 0.9rem;\n  color: var(--text-dark);\n  background: var(--cream);\n  outline: none;\n  transition: border-color 0.2s ease;\n}\n\n.form-input:focus {\n  border-color: var(--gold);\n}\n\n.donate-submit {\n  width: 100%;\n  font-size: 1.05rem;\n  padding: 16px;\n}\n\n.donate-secure {\n  text-align: center;\n  font-size: 0.8rem;\n  color: var(--text-light);\n}\n\n/* Sidebar */\n.donate-sidebar {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  position: sticky;\n  top: 90px;\n}\n\n.impact-card h3,\n.donors-card h3,\n.trust-card h3 {\n  font-size: 1rem;\n  margin-bottom: 16px;\n}\n\n.impact-items {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.impact-item {\n  display: grid;\n  grid-template-columns: 72px 1fr;\n  gap: 10px;\n  align-items: start;\n}\n\n.impact-amount {\n  font-weight: 700;\n  color: var(--gold);\n  font-size: 0.9rem;\n  white-space: nowrap;\n  padding-top: 1px;\n}\n\n.impact-desc {\n  font-size: 0.82rem;\n  color: var(--text-mid);\n  line-height: 1.5;\n}\n\n.donors-list {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.donor-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.donor-avatar {\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, rgba(200,134,10,0.15), rgba(196,72,10,0.1));\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1rem;\n  font-weight: 700;\n  color: var(--gold-dark);\n  flex-shrink: 0;\n}\n\n.donor-info {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 1px;\n}\n\n.donor-info strong {\n  font-size: 0.85rem;\n  color: var(--text-dark);\n}\n\n.donor-info span {\n  font-size: 0.75rem;\n  color: var(--text-light);\n}\n\n.donor-right {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 2px;\n}\n\n.donor-amount {\n  font-size: 0.9rem;\n  font-weight: 700;\n  color: var(--gold-dark);\n}\n\n.donor-time {\n  font-size: 0.72rem;\n  color: var(--text-light);\n}\n\n.trust-card ul {\n  list-style: none;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.trust-card li {\n  font-size: 0.85rem;\n  color: var(--text-mid);\n}\n\n/* Success */\n.success-card {\n  text-align: center;\n  padding: 48px 40px;\n  max-width: 560px;\n  margin: 0 auto;\n}\n\n.success-card h2 {\n  font-size: 1.8rem;\n  margin: 16px 0 12px;\n}\n\n.success-card p {\n  color: var(--text-mid);\n  line-height: 1.8;\n}\n\n@media (max-width: 960px) {\n  .donate-layout {\n    grid-template-columns: 1fr;\n  }\n\n  .donate-sidebar {\n    position: static;\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 20px;\n  }\n\n  .trust-card {\n    grid-column: 1 / -1;\n  }\n}\n\n@media (max-width: 560px) {\n  .causes-grid { grid-template-columns: 1fr; }\n  .amount-grid { grid-template-columns: repeat(2, 1fr); }\n  .donate-sidebar { grid-template-columns: 1fr; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
